<template>
  <div class="languageTab">
    <div v-for="(item,index) in langOptions" :key="index" class="lang_img">
      <img :src="require(`@/assets/img/country/${item.img}`)" height="18" v-show="countryVal == item.value" />
    </div>
    <el-select v-model="countryVal" prefix="el-icon-search" @change="selectLanguage" style="border:none" popper-class="loginDownStyle">
      <el-option v-for="item in langOptions" :key="item.value" :label="item.label" :value="item.value">
        <span style="float: left;margin-right: 10px;">{{ item.label }}</span>
        <span style="float: right; color: #8492a6; font-size: 13px"><img :src="require(`@/assets/img/country/${item.img}`)" style="vertical-align: middle;height: 16px;" /></span>
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import vnLocale from 'element-ui/lib/locale/lang/vi'
import locale from 'element-ui/lib/locale'
import router from '@/router'
export default {
    name: "languageTab",
    data () {
        return {
          countryVal: this.$i18n.locale,
          langOptions: [
            { value: 'en', label: this.$t('other.other_en'), img: 'gb.svg' },
            // { value: 'ae', label: this.$t('other.other_ae'), img: 'ae.svg' },
            { value: 'cn', label: this.$t('other.other_cn'), img: 'cn.svg' }
          ],
        }
    },
    computed: {
      ...mapGetters([
        "logToken"
      ]),
    },
    mounted() {
      console.log(this.$i18n.locale)
    },
    methods: {
      selectLanguage() {
        const long = this.countryVal;
        /* this.$i18n.locale = long
        locale.use(long === 'en' ? enLocale : long === 'cn' ? zhLocale : vnLocale)
        window.localStorage.setItem('lang', long)
        this.$store.commit('SET_KEY') */
        this.$i18n.locale = this.countryVal;
        sessionStorage.setItem('language',this.countryVal);
        window.location.reload();
      },
    },
    components: {

    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.languageTab{
  height: 40px;
  text-align: right;
  position: relative;
  .lang_img {
    display: inline-block;
    position: absolute;
    left: 40px;
    top: 25px;
  }
  img {
    vertical-align: middle;
  }
  .el-input__icon {
    line-height: 25px;
    color: transparent;
  }
  .el-select .el-input .el-select__caret{
    display: none;
  }
}
</style>
<style>
.languageTab .el-input__suffix{
  right: 0;
}
.languageTab .el-input--suffix .el-input__inner{
  color: transparent!important;
}
.languageTab .el-input__icon{
  line-height: 25px;
  color: transparent;
}
.languageTab .el-select .el-input .el-select__caret{
  display: none;
}
</style>



// WEBPACK FOOTER //
// index.vue?59162bb6